import { compact } from 'lodash'

import {
  CPN_COUNTRIES,
  CPN_PAYMENT_METHODS,
  CpnCountryCode,
  CpnPaymentMethod,
} from '@/utils/cpn'

export const TEMPORARILY_UNAVAILABLE_COUNTRIES: CpnCountryCode[] = ['IN']

const PRODUCTION_PAYMENT_METHODS: Partial<
  Record<CpnCountryCode, CpnPaymentMethod[]>
> = {
  NG: ['BANK-TRANSFER'],
  MX: ['SPEI'],
}

const TESTING_PAYMENT_METHODS: Partial<
  Record<CpnCountryCode, CpnPaymentMethod[]>
> = {
  HK: ['FPS', 'CHATS', 'WIRE'],
  PH: ['INSTAPAY', 'PESONET'],
}

const NETWORK_ENV = import.meta.env.VITE_NETWORK_ENV || 'PROD'
const IS_PRODUCTION = NETWORK_ENV === 'PROD'

export const ENABLED_PAYMENT_METHODS_BY_COUNTRY: Partial<
  Record<CpnCountryCode, CpnPaymentMethod[]>
> = IS_PRODUCTION
  ? PRODUCTION_PAYMENT_METHODS
  : CPN_COUNTRIES.reduce(
      (acc, country) => {
        acc[country] = [...CPN_PAYMENT_METHODS]
        return acc
      },
      {} as Record<CpnCountryCode, CpnPaymentMethod[]>
    )

export const getPaymentMethodsForCountry = (
  countryCode: string,
  isTesting: boolean = false
): CpnPaymentMethod[] => {
  const testingMethods = isTesting
    ? TESTING_PAYMENT_METHODS[countryCode]
    : undefined
  const regularMethods = ENABLED_PAYMENT_METHODS_BY_COUNTRY[countryCode]

  return compact([testingMethods, regularMethods])[0] || []
}

export const isPaymentMethodDevMode = (): boolean => {
  return !IS_PRODUCTION
}

export const getPaymentMethodMode = (): string => {
  return NETWORK_ENV
}
